<div class="general-container border border-eggplant-100/[0.25] bg-white">
  <div class="header">
    <div class="flex flex-col header-content border-b border-b-eggplant-100/[0.25]">
      <div class="flex flex-row">
        <div *ngIf="info.status !== 9"
          class="prof-container border-r border-r-eggplant-100/[0.25] flex md:flex-col flex-col-reverse">
          <p class="text-l text-eggplant-100/[0.25] font-sans capitalize">{{ 'PROJECT_LIST.PROFITABILITY' | translate }}
          </p>
          <ng-container *ngIf="moicVariant === 'moic'">
            <p class="text-eggplant-100 uppercase font-sans text-xl md:text-h500 whitespace-nowrap">
              {{ moicValue }}<span
                class="inline-flex items-center !pl-6 gap-2 cursor-help relative has-tooltip text-h300">MOIC
                <fun-icon [name]="'info-circle'"
                  [style]="'w-16 h-16 stroke-eggplant-100 stroke-2 opacity-40'"></fun-icon>
                <span
                  class="font-sans text-s rounded shadow-lg !py-4 !px-6 bg-eggplant-100 text-cream-100 leading-[1.2] -mt-64 tooltip whitespace-normal w-[220px] normal-case">
                  {{ 'DETAIL.MOIC_TOOLTIP' | translate: { moic: moicValue } }}
                </span>
              </span>
            </p>
          </ng-container>
          <ng-container *ngIf="moicVariant !== 'moic'">
            <p class="text-eggplant-100 uppercase font-sans text-xl md:text-h500 whitespace-nowrap">{{info.profitability
              |
              number:'1.0-2':'es'}}<span class="text-h300">% TIR</span></p>
          </ng-container>
        </div>
        <div class="year-container border-r border-r-eggplant-100/[0.25] flex md:flex-col flex-col-reverse">
          <p class="text-l text-eggplant-100/[0.25] font-sans capitalize">{{ 'OVERVIEW_PROJECT.DEAD_LINE' | translate }}
          </p>
          <p *ngIf="info.id !== 162"
            class="text-eggplant-100 uppercase font-sans text-xl md:text-h500 whitespace-nowrap">
            {{info.id !== 130 ?
            info.term : '6,5'}} <span class="text-h300 lowercase">{{ 'OVERVIEW_PROJECT.YEARS' | translate }}</span></p>
          <p *ngIf="info.id === 162"
            class="text-eggplant-100 uppercase font-sans text-xl md:text-h500 whitespace-nowrap">
            2-50 <span class="text-h300 lowercase">{{ 'OVERVIEW_PROJECT.YEARS' | translate }}</span></p>
        </div>
        <div class="inv-container flex flex-col">
          <p *ngIf="showClosedStatusBadge"
            class="font-sans text-s text-center text-eggplant-100/[0.4] uppercase labels cap-label border border-eggplant-100/[0.4] w-fit">
            {{ closedStatusBadgeText }}
          </p>
          <p
            class="font-sans text-s text-center text-eggplant-100/[0.4] uppercase labels cap-label border border-eggplant-100/[0.4] w-fit">
            <span *ngIf="info.type === 1">{{ 'OVERVIEW_PROJECT.LOAN' | translate }}</span>
            <span *ngIf="info.type === 2">{{ 'OVERVIEW_PROJECT.DEBT' | translate }}</span>
          </p>
          <p *ngIf="info.id !== 143 && info.technology !== 5 && (info.technology !== 4 || !info.rechargePoints || (info.rechargePoints && info.rechargePoints === 0))"
            class="font-sans text-s text-center text-eggplant-100/[0.4] uppercase labels border border-eggplant-100/[0.4] w-fit whitespace-nowrap">
            {{info.power | localeNumber}} MW</p>
          <p *ngIf="info.id !== 143 && (info.technology === 4 && info.rechargePoints && info.rechargePoints > 0)"
            class="font-sans text-s text-center text-eggplant-100/[0.4] uppercase labels border border-eggplant-100/[0.4] w-fit whitespace-nowrap">
            {{info.rechargePoints}} puntos</p>
          <p *ngIf="info.id === 143"
            class="font-sans text-s text-center text-eggplant-100/[0.4] uppercase labels border border-eggplant-100/[0.4] w-fit whitespace-nowrap">
            184 puntos</p>
          <p *ngIf="info.technology === 5"
            class="font-sans text-s text-center text-eggplant-100/[0.4] labels border border-eggplant-100/[0.4] w-fit whitespace-nowrap">
            {{info.technologyAmount | localeNumber}} {{info.technologyUnit}}
          </p>
        </div>
      </div>
      <div *ngIf="info.id === 162" class="w-full flex flex-col !mt-12">
        <div class="flex gap-4">
          <p *ngFor="let value of profitabilityOptions"
            class="font-sans text-s text-center uppercase labels cap-label border w-fit hover:cursor-pointer" [ngClass]="{
              'text-white border-orange-80 bg-orange-100': realTimeProfitability === value,
              'text-eggplant-100/[0.4] border-eggplant-100/[0.4]': realTimeProfitability !== value
            }" (click)="setRealTimeProfitability(value)">
            {{ infoRetree[value].percent }}
          </p>
        </div>
        <div class="flex flex-col rounded-2xl bg-orange-100/[0.5] !mb-6 !pt-6 !pb-8 !px-12 text-white">
          <p class="font-sans text-m"><span class="text-m md:text-l pr-6">{{ infoRetree[realTimeProfitability].percent
              }}</span> {{ infoRetree[realTimeProfitability].title }}</p>
          <p class="font-sansLight text-s !leading-[1.2]">{{ infoRetree[realTimeProfitability].text }}</p>
        </div>
        <p class="font-sansLight text-s text-eggplant-100/[.40] [&>a]:text-orange-100 [&>a]:font-bold !leading-[1.2]"
          innerHTML="{{ 'RETREE.INFO' |
          translate }}"></p>
      </div>
    </div>
  </div>
  <div class="subheader flex !pt-24 !pb-32" [ngClass]="{'justify-between' : (originalContributed > 0 && projectStatus > 3) || (info.total > 0 && projectStatus === 3),
    'place-content-end' : !(originalContributed > 0 && projectStatus > 3) || (info.total > 0 && projectStatus === 3),
    'flex-col md:flex-row' : (projectStatus > 4 && projectStatus < 12)}">
    <div class="flex justify-between w-full"
      *ngIf="(originalContributed > 0 && projectStatus > 3) || (info.total > 0 && projectStatus === 3)">
      <div class="flex flex-col content-between">
        <p *ngIf="projectStatus === 3" class="font-sans text-m text-eggplant-100/[0.4]">{{ 'PROJECT_LIST.OBJECTIVE' |
          translate }}</p>
        <p *ngIf="projectStatus > 3" class="font-sans text-m text-eggplant-100/[0.4]">{{
          'PROJECT_LIST.CONTRIBUTED_LABEL' | translate }}</p>
        <p *ngIf="projectStatus === 3"
          class="font-sansMedium text-2xl xl:text-3xl !leading-none w-fit whitespace-nowrap"
          [ngClass]="{'text-[#0f5e42]' : isFlexibleCompensation, 'bg-gradient-2-text linear-gradient-2' : !isFlexibleCompensation}">
          {{info.total | localeNumber}} €</p>
        <p *ngIf="projectStatus > 3" class="font-sansMedium text-2xl xl:text-3xl !leading-none w-fit whitespace-nowrap"
          [ngClass]="{'text-[#0f5e42]' : isFlexibleCompensation, 'bg-gradient-2-text linear-gradient-2' : !isFlexibleCompensation}">
          {{totalRaised | localeNumber}} €</p>
      </div>

      <div class="text-right flex flex-col content-between w-full"
        *ngIf="info.total_official && info.total_official > 0 && (projectStatus === 4 || projectStatus === 12)">
        <ng-container *ngIf="!minExceeded">
          <p class="font-sans text-m text-eggplant-100/[0.4]">{{ 'PROJECT_LIST.OBJECTIVE' | translate }} {{ 'PROJECT_LIST.OBJ_MIN' | translate }}</p>
          <p class="font-sansMedium text-l xl:text-xl text-eggplant-100 !leading-none">{{ info.total_official | number:'1.0-2':'es'}} €</p>
        </ng-container>
        <ng-container *ngIf="minExceeded">
          <p class="font-sans text-m text-eggplant-100/[0.4]">{{ 'PROJECT_LIST.OBJECTIVE' | translate }}</p>
          <p class="font-sansMedium text-l xl:text-xl text-eggplant-100 !leading-none">{{ barData.total_parse }}</p>
          <div class="flex items-center justify-end gap-4 !mt-4">
            <fun-icon [name]="'check-circle'" [style]="'w-12 h-12 stroke-[4px] stroke-success'"></fun-icon>
            <span class="font-sans text-s text-success !leading-none">{{ 'PROJECT_LIST.OBJ_MIN' | translate }}: {{ info.total_official | number:'1.0-2':'es'}} €</span>
          </div>
        </ng-container>
      </div>
      <div class="text-right flex flex-col content-between w-full"
        *ngIf="!(info.total_official && info.total_official > 0) && (projectStatus === 4 || projectStatus === 12)">
        <p class="font-sans text-m text-eggplant-100/[0.4]">{{ 'PROJECT_LIST.OBJECTIVE' | translate }}</p>
        <p class="font-sansMedium text-l xl:text-xl text-eggplant-100 !leading-none">{{ barData.total_parse }}</p>
      </div>
      <div class="text-right flex flex-col content-between w-full" *ngIf="projectStatus === 15">
        <ng-container *ngIf="info.total_official > 0 && !minExceeded">
          <p class="font-sans text-m text-eggplant-100/[0.4]">{{ 'PROJECT_LIST.OBJECTIVE' | translate }} {{ 'PROJECT_LIST.OBJ_MIN' | translate }}</p>
          <p class="font-sansMedium text-l xl:text-xl text-eggplant-100 !leading-none">{{ info.total_official | number:'1.0-2':'es'}} €</p>
        </ng-container>
        <ng-container *ngIf="!(info.total_official > 0) || minExceeded">
          <p class="font-sans text-m text-eggplant-100/[0.4]">{{ 'PROJECT_LIST.OBJECTIVE' | translate }}</p>
          <p class="font-sansMedium text-l xl:text-xl text-eggplant-100 !leading-none">{{ barData.total_parse }}</p>
          <div *ngIf="info.total_official > 0 && minExceeded" class="flex items-center justify-end gap-4 !mt-4">
            <fun-icon [name]="'check-circle'" [style]="'w-12 h-12 stroke-[4px] stroke-success'"></fun-icon>
            <span class="font-sans text-s text-success !leading-none">{{ 'PROJECT_LIST.OBJ_MIN' | translate }}: {{ info.total_official | number:'1.0-2':'es'}} €</span>
          </div>
        </ng-container>
      </div>

      <!--<div class="text-right flex flex-col content-between"
        *ngIf="((projectStatus === 4) || (projectStatus === 12)) && this.daysR <= 7">
        <p class="font-sans text-m text-eggplant-100/[0.4]">{{ 'FORMALITIES.LIMIT_DATE' | translate }}</p>
        <p class="font-sansMedium text-2xl xl:text-3xl text-eggplant-100 !leading-none">{{ this.limitDate }}</p>
      </div>-->
      <div class="text-right flex flex-col content-between w-full"
        *ngIf="(projectStatus !== 4) && (projectStatus !== 12)">
        <p class="font-sans text-m text-eggplant-100/[0.4]" *ngIf="showTotalAsObjective">{{ 'PROJECT_LIST.OBJECTIVE' |
          translate }}</p>
        <p class="font-sansMedium text-2xl xl:text-3xl text-eggplant-100 !leading-none" *ngIf="showTotalAsObjective">
          {{ info.total | localeNumber }} €</p>
        <p class="font-sans text-m text-eggplant-100/[0.4]"
          *ngIf="!showTotalAsObjective && (projectStatus > 4 && projectStatus < 12 && projectStatus !== 9 &&  projectStatus !== 15)">{{
          'OVERVIEW_PROJECT.STATUS' | translate }}</p>
        <p class="font-sansMedium text-2xl xl:text-3xl text-eggplant-100 !leading-none"
          *ngIf="!showTotalAsObjective && (projectStatus > 4 && projectStatus < 12 && projectStatus !== 9 && projectStatus !== 15)">{{
          'OVERVIEW_PROJECT.FINANCIED' | translate }}</p>
        <p class="font-sansMedium text-2xl xl:text-3xl text-eggplant-100 !leading-none"
          *ngIf=" projectStatus === 9 && projectId === 17">{{ 'PROJECT_LIST.SHOLD' | translate }}</p>
        <p *ngIf="projectStatus === 3 && info.total_official > 0" class="font-sans text-m text-eggplant-100/[0.4]">{{
          'PROJECT_LIST.OBJECTIVE' | translate }} {{ 'OVERVIEW_PROJECT.MIN' | translate }}</p>
        <p *ngIf="projectStatus === 3 && info.total_official > 0"
          class="font-sansMedium text-2xl xl:text-3xl !leading-none  text-right"
          [ngClass]="{'text-[#0f5e42]' : isFlexibleCompensation, 'bg-gradient-2-text linear-gradient-2' : !isFlexibleCompensation}">
          {{info.total_official | localeNumber}} €</p>
      </div>
    </div>
  </div>

  <div *ngIf="(projectStatus === 4 || projectStatus === 12 || projectStatus === 15)" class="graphic flex flex-col">
    <div class="pt-28">
      <fun-overview-bar [data]="barData" [hiddeObjetive]="true"
        [hiddeLegend]="false"></fun-overview-bar>
    </div>
    <div class="!pt-24">
      <fun-overviiew-status-avatars [yourInvest]="yourInvest" [yourPendingInvest]="yourPendingInvest"
        [investors]="info.investors" [status]="projectStatus"
        [isFlexibleCompensation]="isFlexibleCompensation"></fun-overviiew-status-avatars>
    </div>
    <!-- Tengo que meter un mensaje de que tu inversión blñabla en funcion a tu estado -->
    <div class="flex gap-6 !p-10 !mt-12 rounded-xl bg-[#EAE7E9] border border-gray-10 backdrop-blur-m"
      *ngIf="priorityInvestedMsg !== null && priorityInvestedMsg !== undefined && yourInvest > 0 && currentStage.type !== 3">
      <fun-icon [name]="'info-circle'" [style]="'w-16 h-16 stroke-[2px] stroke-eggplant-100'"></fun-icon>
      <p class="font-sans text-s text-left leading-[1.25]">{{ priorityInvestedMsg }}</p>
    </div>
    <!-- Mensaje informativo de tu reserva y grupo -->
    <!-- De momento lo comento hasta que se arregle lo de Iberdrola-->
    <div class="flex gap-6 !p-10 !mt-12 rounded-xl border backdrop-blur-m bg-[#EAE7E9] border border-gray-10"
      *ngIf="reservationMsg">
      <fun-icon [name]="'info-circle'" [style]="'w-16 h-16 stroke-[2px] stroke-eggplant-100'"></fun-icon>
      <div class="flex flex-col items-center">
        <p class="font-sans text-s text-left leading-[1.25]">{{ reservationMsg }}</p>
        <p (click)="viewMyPositionInQueue()"
          class="font-sans text-s text-center !py-6 cursor-pointer underline leading-[1.25] w-fit">{{
          'OVERVIEW_PROJECT.RESERVATION.VIEW_POSITION' | translate }}
        </p>
      </div>
    </div>

    <div *ngIf="detailProject?.priority_groups?.length && currentStage && currentStage.type !== 3"
      class="flex items-center justify-between w-full gap-12 !mt-12">
      <div class="flex items-center gap-6 cursor-pointer" (click)="togglePriorityList()">
        <fun-icon [name]="'users'" [style]="'w-16 h-16 md:w-24 md:h-24 stroke-[2px] stroke-orange-100'"></fun-icon>
        <span class="font-sans text-m text-left leading-[1.25]">{{ 'OVERVIEW_PROJECT.GROUPS.HOW.TITLE' | translate
          }}</span>
        <fun-icon [name]="listOpened ? 'chevron-up' : 'chevron-down'"
          [style]="'w-16 h-16 md:w-24 md:h-24 stroke-[4px] stroke-orange-100'"></fun-icon>
      </div>
      <div class="flex gap-6 cursor-help has-tooltip">
        <p class="font-sans text-s text-left leading-[1.25]">{{ 'OVERVIEW_PROJECT.GROUPS.HOW.TXT' | translate }}</p>
        <fun-icon [name]="'info-circle'" [style]="'w-16 h-16 stroke-[2px] stroke-eggplant-100'"></fun-icon>
        <span
          class="font-sans text-s rounded shadow-lg !py-4 !px-6 bg-eggplant-100 text-cream-100 leading-[1.2] -mt-64 tooltip">{{
          'OVERVIEW_PROJECT.GROUPS.HOW.TOOLTIP' | translate }}</span>
      </div>
    </div>

    <div *ngIf="detailProject?.priority_groups?.length"
      class="flex flex-col relative z-10 w-full gap-16 !mt-12 overflow-x-hidden transition-[max-height] duration-500 ease-in-out"
      [ngClass]="{'max-h-0 overflow-hidden': !listOpened, 'max-h-[9999px] md:max-h-[370px] md:overflow-y-auto': listOpened}"
      id="container-list">
      <div *ngFor="let group of detailProject.priority_groups"
        class="flex flex-col gap-2">

        <div class="flex flex-col min-w-0">
          <span *ngIf="detailProject?.postal_code_investment_stages?.length"
            class="text-s font-sans text-eggplant-100/[0.4]">
            {{ 'OVERVIEW_PROJECT.GROUPS.DATE.PREFIX' | translate }}
            <span class="uppercase">{{ detailProject?.postal_code_investment_stages[0].start_date | date:'d MMM' }}</span>
          </span>
          <span class="font-sans text-m text-eggplant-80 leading-snug">G{{ group.priority }} · {{ group.name }}</span>
        </div>

        <div *ngIf="group.contributedOkAmount != null || group.contributedPreOrderAmount != null || group.contributedSignPendingAmount != null"
          class="flex flex-row flex-shrink-0 gap-8">
          <span *ngIf="group.contributedOkAmount != null && group.contributedOkAmount > 0"
            class="font-sans text-s text-eggplant-100/[0.4] whitespace-nowrap">
            Invertido {{ group.contributedOkAmount | number:'1.0-0':'es' }} €
          </span>
          <span *ngIf="((group.contributedPreOrderAmount || 0) + (group.contributedSignPendingAmount || 0)) > 0"
            class="font-sans text-s text-eggplant-100/[0.4] whitespace-nowrap">
            Reservado {{ (group.contributedPreOrderAmount || 0) + (group.contributedSignPendingAmount || 0) | number:'1.0-0':'es' }} €
          </span>
        </div>
      </div>

      <!-- Grupo global -->
      <div *ngIf="hasGlobalPhase" class="flex items-start gap-12">
        <div class="flex flex-col min-w-0">
          <span *ngIf="detailProject?.postal_code_investment_stages?.length"
            class="text-s font-sans text-eggplant-100/[0.4]">
            {{ 'OVERVIEW_PROJECT.GROUPS.DATE.GLOBAL_PREFIX' | translate }}
            <span class="uppercase">{{ detailProject?.postal_code_investment_stages[1].start_date | date:'d MMM' }}</span>
          </span>
          <span class="font-sans text-m text-eggplant-80 leading-snug">G{{ globalGroupNumber }} · {{ 'OVERVIEW_PROJECT.GROUPS.GLOBAL' | translate }}</span>
        </div>
      </div>
    </div>

  </div>
  <div class="flex gap-6 !p-6 !mb-12 rounded-xl border backdrop-blur-m bg-[#EAE7E9] border border-gray-10 w-fit"
    *ngIf="isLocalInvestorsOnly">
    <fun-icon [name]="'info-circle'" [style]="'w-16 h-16 stroke-[2px] stroke-eggplant-100'"></fun-icon>
    <p class="font-sans text-s text-left leading-[1.25]">Este proyecto está reservado únicamente a inversores locales.
    </p>
  </div>
  <div class="flex gap-6 !p-6 !mb-12 rounded-xl border backdrop-blur-m bg-[#EAE7E9] border border-gray-10 w-fit"
    *ngIf="!isLocalInvestorsOnly && detailProject?.canNaturalInvest === true && detailProject?.canLegalInvest === false && profileType === 2">
    <fun-icon [name]="'info-circle'" [style]="'w-16 h-16 stroke-[2px] stroke-eggplant-100'"></fun-icon>
    <p class="font-sans text-s text-left leading-[1.25]">Inversión exclusiva para personas físicas.</p>
  </div>
  <div class="flex gap-6 !p-6 !mb-12 rounded-xl border backdrop-blur-m bg-[#EAE7E9] border border-gray-10 w-fit"
    *ngIf="!isLocalInvestorsOnly && detailProject?.canLegalInvest === true && detailProject?.canNaturalInvest === false && profileType === 1">
    <fun-icon [name]="'info-circle'" [style]="'w-16 h-16 stroke-[2px] stroke-eggplant-100'"></fun-icon>
    <p class="font-sans text-s text-left leading-[1.25]">Inversión exclusiva para personas jurídicas.</p>
  </div>
  <div *ngIf="((projectStatus !== 13 && info.activateInvest) || projectStatus === 14)" class="advise pb-12">
    <fun-new-button *ngIf="(projectStatus === 3)" [buttonType]="btnMain"
      title="{{ 'OVERVIEW.GET_INFORMED' | translate }}" (eventClick)="btnClick('call')" [classExtra]="' !w-full mt-32 '"
      [responsive]="false" [size]="'l'"></fun-new-button>
    <!--Este le deberia de chapar-->
    <fun-new-button [title]="btnInvest" [size]="'xl'"
      [buttonType]="(disableBtnInvest || isProfileRestricted || isLocalInvestorsOnly) ? 'colorFull-disabled' : 'colorFull'"
      (eventClick)="!isProfileRestricted && !isLocalInvestorsOnly && btnClick('invest')"
      *ngIf="projectStatus === 4 || projectStatus === 12 || (projectStatus === 14 && info.available && allowedIncrease)"
      [classExtra]="' !w-full '" [responsive]="false"></fun-new-button>
    <!---->
    <fun-new-button *ngIf="(projectStatus > 4 && projectStatus < 12)" [title]="btnInvested" [size]="'xl'"
      [buttonType]="'secondaryDark'" (eventClick)="btnClick('marketplace')" [classExtra]="' !w-full '"
      [responsive]="false"></fun-new-button>
    <!---->
    <fun-new-button *ngIf="(projectStatus === 15)" size="xl"
      [buttonType]="(disableBtnInvest || isProfileRestricted || isLocalInvestorsOnly) ? 'colorFull-disabled' : btnMain"
      [title]="'Reservar inversión'" (eventClick)="!isProfileRestricted && !isLocalInvestorsOnly && reserveInvestment()"
      [classExtra]="' !w-full '" [responsive]="false"></fun-new-button>
    <fun-new-button *ngIf="(projectStatus === 14 && (!info.available || !allowedIncrease))" [buttonType]="btnMain"
      title="{{ 'OVERVIEW.CAPITAL_INCREASE.READ_MORE' | translate }}" (eventClick)="btnClick('info')"
      [classExtra]="' !w-full '" [responsive]="false"></fun-new-button>
    <div class="cancel_invest !pt-8"
      *ngIf="(projectStatus === 4 || projectStatus === 12 || projectStatus === 5 || projectStatus === 15)">
      <fun-new-button *ngIf="info.canCancel === true" buttonType="ghost" [title]="btnCancelInvestment"
        (eventClick)="editInvest()" [classExtra]="' !w-full '" [size]="'m'" [responsive]="false"></fun-new-button>
      <!-- <fun-new-button *ngIf="yourReservation && yourReservation > 0" buttonType="ghost" title="Cancelar reserva"
        (eventClick)="cancelReservaion()" [classExtra]="' !w-full '" [size]="'m'" [responsive]="false"></fun-new-button> -->
      <fun-new-button
        *ngIf="info.canCancel !== true && (!yourReservation || yourReservation === 0) && (projectStatus === 12 || projectStatus === 4 || projectStatus === 15)"
        buttonType="ghost" title="{{ 'OVERVIEW_PROJECT.CALCULATE_B' | translate }}" (eventClick)="calculateB()"
        [classExtra]="' !w-full '" [size]="'m'" [responsive]="false"></fun-new-button>
    </div>
  </div>
  <div *ngIf="(projectId === 41)" class="textLineZuera"></div>
  <div *ngIf="(projectId === 41)">
    <p class="zueraText">* {{ 'DETAIL_PROJECT_BENEFITS' | translate }}</p>
  </div>
  <div *ngIf="(projectStatus === 3 && info.available === true)" class="pb-12">
    <fun-new-button *ngIf="(projectStatus === 3 && info.available === true)" buttonType="colorFull" [title]="btnInvest"
      id="begin-checkout" (eventClick)="btnClick('invest')" [classExtra]="' !w-full '" [responsive]="false"
      [size]="'m'"></fun-new-button>
  </div>
  <div
    *ngIf="projectStatus === 15 || (projectStatus > 4 && projectStatus < 12) || ((contributed > info.total_official) && totalOfficialPercent)"
    class="flex rounded-xl"
    [ngClass]="{
      '!mt-12 !pt-24 border-t border-t-eggplant-100/[0.4]' : (projectStatus > 4 && projectStatus < 12),
      '!p-12 bg-[#15803d]/[0.08]': (projectStatus === 4 || projectStatus === 12) && minExceeded
    }">
    <div class="icon-container">
      <fun-icon [name]="'info-circle'"
        [style]="((projectStatus === 4 || projectStatus === 12) && minExceeded) ? 'w-24 h-24 stroke-[#15803d] stroke-4' : 'w-24 h-24 stroke-gray-40 stroke-4'">
      </fun-icon>
    </div>
    <div class="info-container">
      <div *ngIf="(projectStatus > 4 && projectStatus < 12)">
        <p class="font-sansMedium font-medium text-m text-gray-40">{{ 'OVERVIEW_PROJECT.LABEL_INFO_1' | translate }}</p>
        <p class="font-sans text-m text-gray-40">{{ 'OVERVIEW_PROJECT.TXT_INFO_1' | translate }}</p>
      </div>
      <div *ngIf="projectStatus === 15">
        <p class="font-sans text-m text-gray-40">{{ 'OVERVIEW_PROJECT.TXT_INFO_2' | translate }}</p>
      </div>
      <div *ngIf="(projectStatus === 4 || projectStatus === 12) && (contributed > info.total_official)">
        <p class="font-sansMedium font-medium text-m text-[#15803d]">{{ 'OVERVIEW_PROJECT.LABEL_INFO_1' | translate }}</p>
        <p class="font-sans text-m text-[#15803d]">{{ 'OVERVIEW_PROJECT.TXT_INFO_3' | translate }}</p>
      </div>

    </div>
  </div>

  <div *ngIf="vinculationMap && (vinculationMap['invest'] !== null || vinculationMap['validation'] !== null)"
    class="flex gap-6">
    <div class="icon-container">
      <fun-icon [name]="'info-circle'" [style]="'w-24 h-24 stroke-gray-40 stroke-2'"></fun-icon>
    </div>
    <div>
      <p *ngIf="vinculationMap['invest'] !== null && vinculationMap['invest'] !== undefined && vinculationMap['invest'] !== ''"
        class="font-sans text-m text-gray-40">{{ 'INFO.VINCULATION_STATUS_1' | translate }}: <span class="uppercase">{{
          vinculationMap['invest'] }}</span></p>
      <p *ngIf="vinculationMap['validation'] !== null && vinculationMap['validation'] !== undefined && vinculationMap['validation'] !== ''"
        class="font-sans text-m text-gray-40">{{ 'INFO.VINCULATION_STATUS_2' | translate }}: <span class="uppercase">{{
          vinculationMap['validation'] }}</span></p>
    </div>
  </div>
</div>

<div *ngIf="info.hasDocuments && projectStatus >= 3">
  <fun-new-document (onClickEvent)="downloadAllDocuments()"></fun-new-document>
</div>